import type { StoryBlockProps } from "../../components/StoryBlock/StoryBlock";
import { useStoryBlockRuntime } from "./useStoryBlockRuntime";

export function useStoryBlockCore(props: Readonly<StoryBlockProps>) {
  return useStoryBlockRuntime(props);
}
